module.exports = __webpack_public_path__ + "main/images/shared/fuel-your-mind.4ab835a9cbfee804b36d11b7ee83e7a5.png";